module.exports = __webpack_public_path__ + "img/laptop-mobile.e3ea720e.png";